"use strict";
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
Object.defineProperty(exports, "__esModule", { value: true });
exports.MerkleDistributor__factory = void 0;
const ethers_1 = require("ethers");
const _abi = [
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "caller",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "windowIndex",
                type: "uint256",
            },
            {
                indexed: true,
                internalType: "address",
                name: "account",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "accountIndex",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
            {
                indexed: true,
                internalType: "address",
                name: "rewardToken",
                type: "address",
            },
        ],
        name: "Claimed",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "uint256",
                name: "windowIndex",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "rewardsDeposited",
                type: "uint256",
            },
            {
                indexed: true,
                internalType: "address",
                name: "rewardToken",
                type: "address",
            },
            {
                indexed: false,
                internalType: "address",
                name: "owner",
                type: "address",
            },
        ],
        name: "CreatedWindow",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "uint256",
                name: "windowIndex",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "address",
                name: "owner",
                type: "address",
            },
        ],
        name: "DeleteWindow",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "previousOwner",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "OwnershipTransferred",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "owner",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
            {
                indexed: true,
                internalType: "address",
                name: "currency",
                type: "address",
            },
        ],
        name: "WithdrawRewards",
        type: "event",
    },
    {
        inputs: [
            {
                components: [
                    {
                        internalType: "uint256",
                        name: "windowIndex",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "amount",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "accountIndex",
                        type: "uint256",
                    },
                    {
                        internalType: "address",
                        name: "account",
                        type: "address",
                    },
                    {
                        internalType: "bytes32[]",
                        name: "merkleProof",
                        type: "bytes32[]",
                    },
                ],
                internalType: "struct MerkleDistributorInterface.Claim",
                name: "_claim",
                type: "tuple",
            },
        ],
        name: "claim",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                components: [
                    {
                        internalType: "uint256",
                        name: "windowIndex",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "amount",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "accountIndex",
                        type: "uint256",
                    },
                    {
                        internalType: "address",
                        name: "account",
                        type: "address",
                    },
                    {
                        internalType: "bytes32[]",
                        name: "merkleProof",
                        type: "bytes32[]",
                    },
                ],
                internalType: "struct MerkleDistributorInterface.Claim[]",
                name: "claims",
                type: "tuple[]",
            },
        ],
        name: "claimMulti",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "windowIndex",
                type: "uint256",
            },
        ],
        name: "deleteWindow",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "windowIndex",
                type: "uint256",
            },
        ],
        name: "getRewardTokenForWindow",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "windowIndex",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "accountIndex",
                type: "uint256",
            },
        ],
        name: "isClaimed",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        name: "merkleWindows",
        outputs: [
            {
                internalType: "bytes32",
                name: "merkleRoot",
                type: "bytes32",
            },
            {
                internalType: "uint256",
                name: "remainingAmount",
                type: "uint256",
            },
            {
                internalType: "contract IERC20",
                name: "rewardToken",
                type: "address",
            },
            {
                internalType: "string",
                name: "ipfsHash",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "nextCreatedIndex",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "owner",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "renounceOwnership",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "rewardsToDeposit",
                type: "uint256",
            },
            {
                internalType: "address",
                name: "rewardToken",
                type: "address",
            },
            {
                internalType: "bytes32",
                name: "merkleRoot",
                type: "bytes32",
            },
            {
                internalType: "string",
                name: "ipfsHash",
                type: "string",
            },
        ],
        name: "setWindow",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "transferOwnership",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                components: [
                    {
                        internalType: "uint256",
                        name: "windowIndex",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "amount",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "accountIndex",
                        type: "uint256",
                    },
                    {
                        internalType: "address",
                        name: "account",
                        type: "address",
                    },
                    {
                        internalType: "bytes32[]",
                        name: "merkleProof",
                        type: "bytes32[]",
                    },
                ],
                internalType: "struct MerkleDistributorInterface.Claim",
                name: "_claim",
                type: "tuple",
            },
        ],
        name: "verifyClaim",
        outputs: [
            {
                internalType: "bool",
                name: "valid",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract IERC20",
                name: "rewardCurrency",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "withdrawRewards",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
];
const _bytecode = "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";
class MerkleDistributor__factory extends ethers_1.ContractFactory {
    constructor(...args) {
        if (args.length === 1) {
            super(_abi, _bytecode, args[0]);
        }
        else {
            super(...args);
        }
    }
    deploy(overrides) {
        return super.deploy(overrides || {});
    }
    getDeployTransaction(overrides) {
        return super.getDeployTransaction(overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new ethers_1.utils.Interface(_abi);
    }
    static connect(address, signerOrProvider) {
        return new ethers_1.Contract(address, _abi, signerOrProvider);
    }
}
exports.MerkleDistributor__factory = MerkleDistributor__factory;
MerkleDistributor__factory.bytecode = _bytecode;
MerkleDistributor__factory.abi = _abi;
